import { forwardRef, useState } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import styles from "./About.module.css";
import { MdMail, MdPhone } from "react-icons/md";

const About = forwardRef((props, ref) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    purpose: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");

  const SITEKEY = "0x4AAAAAAB_TjG7TUS0op97J"; // Replace with live key when ready

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim() || !/^\S+@\S+\.\S+$/.test(formData.email))
      newErrors.email = "Valid email is required";
    if (!formData.phoneNumber.trim()) newErrors.phoneNumber = "Phone number is required";
    if (!formData.purpose) newErrors.purpose = "Please select a purpose";
    if (!formData.message.trim()) newErrors.message = "Message is required";
    if (!turnstileToken) newErrors.captcha = "Please complete the security check";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");
    setErrors({});

    if (!validateForm()) return;

    try {
      const response = await fetch(
        "https://prod.toxboxai.com/api/contactdata/createContactData",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...formData,
            turnstileToken,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || "Submission failed");
      }

      setStatus("Thank you! We'll get back to you soon.");
      setFormData({ name: "", email: "", phoneNumber: "", purpose: "", message: "" });
      setTurnstileToken(""); // Reset captcha
    } catch (error) {
      setStatus(`Error: ${error.message}`);
      setTurnstileToken("");
    }
  };

  return (
    <div className={styles.mainContainer} ref={ref}>
                  <h1 className={styles.contactTitle}>Contact Us</h1>

      {/* Contact Section - Matches Figma Design */}
      <section id="contact" className={styles.contactSection}>
        
        <div className={styles.contactOverlay}></div>

        <div className={styles.contactContent}>
          {/* Left Text Side */}
          <div className={styles.contactTextContainer}>
            <h2 className={styles.contactSubtitle}>
              Let's Make Communication<br />
              Easier—Together
            </h2>
            <p className={styles.contactDescription}>
              We're happy to answer your questions or walk you through our platform.
              Let us know how we can help.
            </p>

            <div className={styles.contactInfo}>
              <div className={styles.contactItem}>
                <span className={styles.icon}><MdMail /></span>
                <a href="mailto:sales@provaantech.com">sales@provaantech.com</a>
              </div>
              <div className={styles.contactItem}>
                <span className={styles.icon}><MdPhone /></span>
                <a href="tel:+918548985632">8548985632</a>
              </div>
            </div>
          </div>

          {/* Right Form Side */}
          <div className={styles.contactFormWrapper}>
            <form onSubmit={handleSubmit} className={styles.contactForm}>
              <div className={styles.formGrid}>
                <div className={styles.inputGroup}>
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your name"
                  />
                  {errors.name && <span className={styles.error}>{errors.name}</span>}
                </div>

                <div className={styles.inputGroup}>
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="your@email.com"
                  />
                  {errors.email && <span className={styles.error}>{errors.email}</span>}
                </div>

                <div className={styles.inputGroup}>
                  <label>Phone no.</label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    placeholder="+91 9876543210"
                  />
                  {errors.phoneNumber && <span className={styles.error}>{errors.phoneNumber}</span>}
                </div>

                <div className={styles.inputGroup}>
                  <label>Select a Purpose</label>
                  <select
                    name="purpose"
                    value={formData.purpose}
                    onChange={handleInputChange}
                  >
                    <option value="">Select a purpose</option>
                    <option value="General Contact">General Contact</option>
                    <option value="Inquiry">Inquiry</option>
                    <option value="Demo">Demo Request</option>
                    <option value="Developer Meeting">Developer Meeting</option>
                  </select>
                  {errors.purpose && <span className={styles.error}>{errors.purpose}</span>}
                </div>

                <div className={`${styles.inputGroup} ${styles.fullWidth}`}>
                  <label>How can Tox Box help you grow?</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="2"
                    placeholder="Tell us about your needs..."
                  />
                  {errors.message && <span className={styles.error}>{errors.message}</span>}
                </div>

                {/* Turnstile CAPTCHA */}
                <div className={`${styles.inputGroup}`}>
                  <Turnstile
                    siteKey={SITEKEY}
                    onSuccess={setTurnstileToken}
                    onExpire={() => setTurnstileToken("")}
                    onError={() => setTurnstileToken("")}
                  />
                  {errors.captcha && <span className={styles.error}>{errors.captcha}</span>}
                </div>

                {/* Attachment (Optional - UI only) */}
                {/* <div className={`${styles.inputGroup}`}>
                  <label className={styles.attachmentLabel}>
                    <span>+</span> Attach your company profile. (less than 10MB)
                  </label>
                  <input type="file" accept=".pdf,.doc,.docx" className={styles.fileInput} />
                </div> */}

                     <button type="submit" className={styles.submitBtn}>
                Submit
              </button>
              </div>

         

              {status && (
                <p className={status.includes("Thank you") || status.includes("successfully")
                  ? styles.successMessage
                  : styles.errorMessage
                }>
                  {status}
                </p>
              )}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
});

About.displayName = "About";
export default About;